// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__GnxON","btnOffer":"AddProduct_btnOffer__o+AYZ"};